import React from 'react';
import { Button } from 'antd';
import { PrinterOutlined } from '@ant-design/icons';
import './Print.css';

const PrintButton = () => {
  return (
    <Button
      className="no-print"
      icon={<PrinterOutlined />}
      onClick={() => window.print()}
    >
      طباعة
    </Button>
  );
};

export default PrintButton;